import { ICollectionTile } from "@faire/web-api--source/indigofair/data/ICollectionTile";
import React from "react";
export var CollectionTileClickImpressionContext = React.createContext({
    screenContext: ICollectionTile.Screen.SCREEN_UNKNOWN,
    containerContext: ICollectionTile.ScreenContainer.SCREEN_CONTAINER_UNKNOWN,
    requestId: undefined,
    contextToken: undefined
});
CollectionTileClickImpressionContext.displayName = "CollectionTileClickImpressionContext";
